import React from 'react';
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styled from 'styled-components';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {useGetdesignationsQuery} from '../../../features/designations/designationApiSlice';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { useAddBulkofficetypeMutation, useGetofficetypeQuery } from '../../../features/officetype/officetypeApiSlice';
import { useAddBulkofficeMutation } from '../../../features/offices/officesApiSlice';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';


const Adduserformcont = styled.div`
  display: flex;
  margin-left: 30px;
`
const LabelInputWrapper = styled.div`
    /* margin-bottom:25px; */
    min-height: 80px;
    margin-right:20px;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
// const SubmitButton = styled.button`
// display: inline-flex;
// -webkit-box-align: center;
// -webkit-box-pack: center;
// justify-content: center;
// position: relative;
// box-sizing: border-box;
// cursor: pointer;
// font-family: "Roboto","Helvetica","Arial",sans-serif;
// font-weight: 500;
// font-size: 0.75rem;
// line-height: 1.75;
// letter-spacing: 0.02857em;
// text-transform: uppercase;
// width:200px;
// /* min-width: 64px; */
// height: 35px;
// padding: 6px 16px;
// border-radius: 4px;
// border-width: 0;
// background-color: #5C5891;
// box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
// margin-left: 20px;
// color: #fff;
// `
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
margin-left: 25px;
width:120px;
font-size: 0.9rem;
`

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;  


const AddOfficeType = ({setAddOffTypePage, officetype, offices}) => {

const [addSpecIndex, setAddSpecIndex] = useState(1);
const [value, setValue] = useState({})

const {designations} = useGetdesignationsQuery("desigList", {
  selectFromResult: ({ data }) => ({
    designations: data?.entities
  }),
})

const [addBulkOffType] = useAddBulkofficetypeMutation();
const [addBulkOff] = useAddBulkofficeMutation();



const onChangeuserform = (event, newValue, name) =>{
  let tempValue = structuredClone(value);
  console.log(event.target.value)

  if(event.target.name?.includes('name')){
    tempValue[event.target.name] = event.target.value;    
  }

  if(name?.includes('type') || name?.includes('superioroffice')){
    tempValue[name] = newValue;
  }
  setValue(tempValue)
}

console.log(value)

const onClickaddicon = () =>{
  let tempValue = {...value};
  tempValue[`type${addSpecIndex}`] = tempValue[`type${addSpecIndex-1}`];
  tempValue[`superioroffice${addSpecIndex}`] = tempValue[`superioroffice${addSpecIndex-1}`];
  console.log(tempValue);
  setValue(tempValue);
  setAddSpecIndex(addSpecIndex+1);
}

const onClickremoveicon = () =>{
  if(addSpecIndex > 1){
    setAddSpecIndex(addSpecIndex-1)
    }
}

const onClickBackArrow = () =>{
  setAddOffTypePage(false)
}

const handleFormSubmit = async (e) => {
  e.preventDefault();
  const tempValue = structuredClone(value);
  let tempArray = [];
  for(let i=0; i< addSpecIndex; i++){
    console.log(Object.values(officetype).find(x => x.type === tempValue[`type${i}`]).level)
    if(!(tempValue[`name${i}`]?.length && tempValue[`type${i}`]?.length && tempValue[`superioroffice${i}`]?.length) && (Object.values(officetype).find(x => x.type === tempValue[`type${i}`]).level !== "level1" )  ){
      return alert("Please Select/Enter all values befor Submit.")
    }
    let tempObject = {};
    tempObject["name"] = tempValue[`name${i}`];
    tempObject["type"] = tempValue[`type${i}`];
    tempObject["level"] = Object.values(officetype).find(x => x.type === tempValue[`type${i}`]).level ;
    tempObject["superioroffice"] = tempValue[`superioroffice${i}`];
    tempObject["unitHead"] = "";
    tempObject["Bo"] = "";
    tempArray.push(tempObject);
  }
  const nameArray = Object.values(offices).map(item => item.name);
  const filteredArray = tempArray.filter(item => !nameArray.includes(item.name));
  const result = await addBulkOff(filteredArray)
  if(result.data.acknowledged){
    setValue({});
    setAddSpecIndex(1);
    alert(`A total of ${result.data.insertedCount} Office entries have been added`)
  }
  console.log(result)
}

return (
    <>
    <BackArrowContainer onClick={onClickBackArrow}><ArrowLeftIcon /><span >Back to Office Table</span></BackArrowContainer>
    <HeadingWrap>
      <Span>Add New Office/Offices</Span>
    </HeadingWrap>
    <form onSubmit={handleFormSubmit} style={{marginTop:"20px"}}>
    {[...Array(addSpecIndex)].map((e, i) =>
      <Adduserformcont key={i}>
      <LabelInputWrapper>
        <TextField
          id="outlined-basic"
          size='small'
          name={`name${i}`}
          onChange={(event, newValue) => onChangeuserform(event, newValue)}
          label="Office Name"
          value={value[`name${i}`]?.length? value[`name${i}`]: ""}
          variant="outlined"
          sx={{ backgroundColor:"white" }}
          // onFocus={() => setFirstNameFocus(true)}
          // onBlur={() => setFirstNameFocus(false)}
          // sx={{width:"100%"}}
        />      
      </LabelInputWrapper>

      <LabelInputWrapper>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          size='small'
          value={value[`type${i}`]?.length? value[`type${i}`]:null}
          onChange={(event, newValue) => onChangeuserform(event, newValue, `type${i}`)}
          options={Object.values(officetype).sort((a,b)=>{
            //We are using sort Algorithm to sort the Office types based on Level.
            let numA = parseInt(a.level.match(/\d+/)[0]);
            let numB = parseInt(b.level.match(/\d+/)[0]);                  
            return numA - numB;
          }).map(x=>x.type)}
          sx={{ minWidth: "180px", backgroundColor:"white" }}
          renderInput={(params) => <TextField {...params} label={"Select Office Type"} />}
        />             
      </LabelInputWrapper>

      <LabelInputWrapper>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          size='small'
          value={value[`superioroffice${i}`]?.length? value[`superioroffice${i}`]:null}
          onChange={(event, newValue) => onChangeuserform(event, newValue, `superioroffice${i}`)}
          options={Object.values(offices).map(x => x.name).concat(Object.entries(value).filter(x => (parseInt(x[0].slice(-1)) < i) && (x[0].includes("name"))).map(x=>x[1]))}
          sx={{ minWidth: "200px", backgroundColor:"white" }}
          renderInput={(params) => <TextField {...params} label={"Select Superior Office"} />}
        />
      </LabelInputWrapper>
      
      {i === (addSpecIndex -1) &&  <><AddIcon onClick={onClickaddicon} sx={{ fontSize: 30 }} />
      <RemoveIcon onClick={onClickremoveicon} sx={{ fontSize: 30 }} /></>}
    </Adduserformcont>
    )}
    <SubmitButton type='submit' >Submit</SubmitButton>
    </form>
    </>
  )
}

export default AddOfficeType